import React from 'react'
import { Formik, ErrorMessage } from 'formik';
import { FileDropZone } from '../../_metronic/layout/components/dropzone/FileDropZone'
import FormFooterButtons from '../components/FormFooterButtons';
import { Card } from 'react-bootstrap';
import { ward } from '../data/institute';

const Mill = (props) => (

    <div>
        <Formik
            enableReinitialize
            initialValues={props.data ? props.data : {
                ward: "",
                moistureCenter: "",
                traditionalCount: "",
                renovateCount: "",
                waterMill: "",
                dieselMill: "",
                electricityMill: "",
                agriculture: "",
                ayurvedic: "",
                industry: "",
                koseliGhar: "",
            }}
            validate={values => {
                const errors = {};
                // if (!values.name) {
                //     errors.name = 'Required';
                // }
                // if (!values.pondAddress) {
                //     errors.pondAddress = 'Required';
                // }
                // if (!values.address) {
                //     errors.address = 'Required';
                // }
                // if (!values.area) {
                //     errors.area = 'Required';
                // }
                // if (!values.farmType) {
                //     errors.farmType = 'Required';
                // }
                // if (!values.unit) {
                //     errors.unit = 'Required';
                // }
                // if (!values.rate) {
                //     errors.rate = 'Required';
                // }
                // if (!values.animal) {
                //     errors.animal = 'Required';
                // }
                // if (!values.presidentContact) {
                //     errors.presidentContact = 'Required';
                // }
                // if (!values.presidentName) {
                //     errors.presidentName = 'Required';
                // }
                // if (!values.total) {
                //     errors.total = 'Required';
                // }
                // if (!values.fetotal) {
                //     errors.fetotal = 'Required';
                // }
                return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                    props.submit(values);
                    setSubmitting(false);
                }, 400);
            }}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
                handleReset, }) => (
                <>
                    <form className="form survey-form" onSubmit={handleSubmit}>
                        <Card>
                            <Card.Body>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >वडा नम्बर </label>
                                        <select
                                            className="form-control"
                                            id="ward"
                                            name="ward"
                                            onChange={handleChange}
                                            value={values.ward}
                                        >
                                            {ward.map((woda) => (
                                                <option value={woda.value}>{woda.nepali}</option>
                                            ))}
                                        </select>
                                        <ErrorMessage className="invalid-feedback" name="ward" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >परम्परागत</label>
                                        <input type="number" className="form-control" placeholder="परम्परागत" name="traditionalCount" onChange={handleChange} value={values.traditionalCount} />
                                        <ErrorMessage className="invalid-feedback" name="traditionalCount" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-control-label" >सुधारिएको</label>
                                        <input type="number" className="form-control" placeholder="सुधारिएको" name="renovateCount" onChange={handleChange} value={values.renovateCount} />
                                        <ErrorMessage className="invalid-feedback" name="renovateCount" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >पानी मिल</label>
                                        <input type="number" className="form-control" placeholder="पानी मिल" name="waterMill" onChange={handleChange} value={values.waterMill} />
                                        <ErrorMessage className="invalid-feedback" name="waterMill" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-control-label" >डिजेल मिल</label>
                                        <input type="number" className="form-control" placeholder="डिजेल मिल" name="dieselMill" onChange={handleChange} value={values.dieselMill} />
                                        <ErrorMessage className="invalid-feedback" name="dieselMill" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >विधुत मिल</label>
                                        <input type="number" className="form-control" placeholder="विधुत मिल" name="electricityMill" onChange={handleChange} value={values.electricityMill} />
                                        <ErrorMessage className="invalid-feedback" name="electricityMill" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >कृषि</label>
                                        <input type="number" className="form-control" placeholder="कृषि" name="agriculture" onChange={handleChange} value={values.agriculture} />
                                        <ErrorMessage className="invalid-feedback" name="agriculture" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-control-label" >जडिबुटी</label>
                                        <input type="number" className="form-control" placeholder="जडिबुटी" name="ayurvedic" onChange={handleChange} value={values.ayurvedic} />
                                        <ErrorMessage className="invalid-feedback" name="ayurvedic" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >उधोग</label>
                                        <input type="number" className="form-control" placeholder="उधोग" name="industry" onChange={handleChange} value={values.industry} />
                                        <ErrorMessage className="invalid-feedback" name="industry" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-control-label" >चिस्यान केन्द्र</label>
                                        <input type="number" className="form-control" placeholder="चिस्यान केन्द्र" name="moistureCenter" onChange={handleChange} value={values.moistureCenter} />
                                        <ErrorMessage className="invalid-feedback" name="moistureCenter" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >विक्री केन्द्र वा कोसेली घर</label>
                                        <input type="number" className="form-control" placeholder="विक्री केन्द्र वा कोसेली घर" name="koseliGhar" onChange={handleChange} value={values.koseliGhar} />
                                        <ErrorMessage className="invalid-feedback" name="koseliGhar" component="div" />
                                    </div>
                                </div>
                                <div className="card-footer text-right">
                                    <FormFooterButtons />
                                </div>
                            </Card.Body>
                        </Card>
                    </form>
                </>
            )}
        </Formik>
    </div>

)

export default Mill;